import Employees from 'components/Employees';
import PermissionGuard from 'components/Global/PermissionGuard';

export const EmployeesPage = () => {
	return (
		<PermissionGuard permission="Allow_Employment">
			<Employees />
		</PermissionGuard>
	);
};
